import { render } from "./AddressMutation.vue?vue&type=template&id=7b88b4fa&scoped=true"
import script from "./AddressMutation.vue?vue&type=script&lang=js"
export * from "./AddressMutation.vue?vue&type=script&lang=js"

import "./AddressMutation.vue?vue&type=style&index=0&id=7b88b4fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b88b4fa"]])

export default __exports__